import { HttpClient } from '../../../../domain/http';
import { HttpClientAdapter, HttpRequest } from '../../../../infra/adapters';
import { LoginData } from '../../../../application/data';
import React from 'react';
export const MakeLogin = () => {
  const httpRequest: HttpRequest = {
    url: `${process.env.REACT_APP_API_CONECTA}/servico/login/session`,
    method: 'post',
  };

  const httpClientAdapter = new HttpClientAdapter();
  const httpClient = new HttpClient(httpClientAdapter, httpRequest);

  return new LoginData(httpClient);
};
